<div id="verify_container">
  <h1 [cypress]="'page_title'" class="nes-mb-3 verify-page-title">
    {{ "VERIFY.TITLE" | translate }}
  </h1>

  <ng-container *ngIf="(totalProductCount$ | async) > 0; else emptyCart">
    <section class="product-summary-section">
      <bca-product-summary></bca-product-summary>
    </section>

    <p class="dtd-caption">{{ 'VERIFY.DTD_CAPTION' | translate }}</p>

    <ng-container *ngIf="(cartProducts$ | async)?.length > 0">
      <div class="mobile-cart lg:nes-hidden">
        <aside class="order-cart">
          <h3 class="cart-title">
            <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
            <span class="cart-title__line2">{{ totalProductCount$ | async }} NS-Business Card{{ (totalProductCount$ | async) > 1 ? 's' : '' }}</span>
          </h3>

          <ng-container *ngFor="let product of cartProducts$ | async">
            <div class="cart-product-box">
              <div class="cart-row cart-row--name" *ngIf="product.user">
                <span>{{ product.user | displayName | async }}</span>
              </div>
              <div class="cart-row">
                <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
                <span>€ {{ product.price | priceFormat }}</span>
              </div>
              <ng-container *ngFor="let addon of product.addons">
                <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
                  <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
                  <span>€ {{ addon.price | priceFormat }}</span>
                </div>
                <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
                  <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
                  <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="cart-subtotals">
            <div class="cart-row">
              <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
              <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
            </div>
            <div class="cart-row">
              <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
              <span>€ {{ cartTax$ | async | priceFormat }}</span>
            </div>
          </div>

          <hr class="cart-separator" />

          <div class="cart-total-row">
            <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
            <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
          </div>
        </aside>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #emptyCart>
    <div class="empty-state-info-box">
      <p class="empty-state-title">{{ 'VERIFY.EMPTY_CART.TITLE' | translate }}</p>
      <p class="empty-state-subtitle">{{ 'VERIFY.EMPTY_CART.SUBTITLE' | translate }}</p>
    </div>
    <nes-divider class="nes-mb-5"></nes-divider>
  </ng-template>

  <footer class="verify-sticky-footer">
    <button
      class="add-card-btn"
      [disabled]="!(allowNewProduct$ | async)"
      type="button"
      (click)="addNewProduct()"
    >
      <i class="icon plus-circle--small"></i>
      {{ (totalProductCount$ | async) === 0 ? ('VERIFY.BUTTON.ADD_FIRST_PRODUCT' | translate) : ('BUTTON.ADD_PRODUCT' | translate) }}
    </button>
    <div class="lg:nes-hidden">
      <nes-button
        [cypress]="'next_page'"
        variant="brand"
        icon-trailing="true"
        (click)="nextRoute()"
      >
        {{ 'VERIFY.BUTTON.CONTINUE_ORDER' | translate }}
      </nes-button>
    </div>
  </footer>
</div>
